<input type="text" [formControl]="searchControl" class="form-control location-search-input"
       placeholder="Search Location" aria-label="Search Location" autocomplete="off">
<button type="button" class="btn btn-link" [disabled]="resolving" (click)="getCurrentLocation(true)">Use my location</button>
<p *ngIf="searching || resolving" role="status">{{ resolving ? 'Finding the address…' : 'Searching…' }}</p>
<p *ngIf="searchError" role="status" class="text-danger">{{ searchError }}</p>
<ul class="location-list" *ngIf="suggestions.length > 0">
  <li *ngFor="let suggestion of suggestions" (click)="onLocationSelect(suggestion)"
      tabindex="0" role="button" (keydown.enter)="onLocationSelect(suggestion)">
    <img src="./assets/images/ic-location-select.svg" alt="Icon">
    <p>{{ suggestion.description }}</p>
  </li>
</ul>
<div class="location-preview-block">
  <div class="frame-inner" style="width: 100%; height: 100%;">
    <google-map *ngIf="mapsReady" class="google-map" [center]="initialCoordinates" [options]="mapOptions" [zoom]="zoom" width="100%"
                (mapInitialized)="onMapInitialized($event)"></google-map>
    <p *ngIf="!mapsReady && !mapError" role="status">Loading map…</p>
    <div *ngIf="mapError" role="status">
      <p>{{ mapError }}</p>
      <button type="button" class="btn btn-outline-primary" (click)="loadMap()">Retry map</button>
    </div>
  </div>
</div>
